module.exports = require("lodash/constant");